import { render, staticRenderFns } from "./UserExamList.vue?vue&type=template&id=c5ca270a"
import script from "./UserExamList.vue?vue&type=script&lang=js"
export * from "./UserExamList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports